<template>
  <section class=" page-doc-item">
    <op-menu :dataList="dataList"> </op-menu>
    <section class="doc__content">
      <!-- <op-bread></op-bread> -->
      <router-view />
    </section>
  </section>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import opMenu from "@/components/views/doc/menu.vue";
// import opBread from "@/components/common/bread.vue";
export default {
  data() {
    return {
      dataList: [
        {
          menuName: "API测试",
          menuCode: "api-test",
          route: {
            name: "api-test",
            params: { menuCode: "api-test" }
          }
        },
        {
          menuName: "错误码排查",
          menuCode: "error-code-test",
          route: {
            name: "error-code-test",
            params: { menuCode: "error-code-test" }
          }
        }
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {
    opMenu
    //   opBread
  }
};
</script>

<style lang="less">
.page-doc-item {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  padding-top: 40px;
  min-height: 600px;

  .doc__content {
    flex-grow: 1;
    padding-left: 60px;
  }
}
</style>
